
    $(document).ready(function(){

      $('body').on('click', '.soreboardBtn',function(){
        $('.singleFieldView ').removeClass('liveInfoActive');
        $('.singleFieldView ').addClass('scoreboardActive');
      });
      $('body').on('click', '.liveInfoBtn',function(){
        $('.singleFieldView ').removeClass('scoreboardActive');
        $('.singleFieldView ').addClass('liveInfoActive');
        reloadFrame();
      });
      $('body').on('click', '.singleFirstCatBtn',function(){
        $('.singleMatchBetModule').removeClass('active');
        $('.singleFirstCatContainer').addClass('active');
      });

      $('body').on('click', '.singleSecondCatBtn',function(){
        $('.singleMatchBetModule').removeClass('active');
        $('.singleSecondCatContainer').addClass('active');
      });


      $('body').on('click', '.singleMatchCatBtn',function(e){
        $('.singleMatchCatBtn').removeClass('active');
        $(this).addClass('active');
      });


      function getBetDetail() {
        alert($(this).id);
      }

      function reloadFrame() {
        console.log('para')
        $("#iframe").attr("src", function (index, attr) {
          console.log('pas')
          return attr;
        });
      }

    });
